/**
 * @flow
 * @relayHash 6dff3ead9e85d0b5a7e755e946608a4b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type instantSearch_viewer$ref = any;
export type instantSearchRefetchQueryVariables = {|
  query?: ?string,
|};
export type instantSearchRefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: instantSearch_viewer$ref,
  |},
|};
*/


/*
query instantSearchRefetchQuery(
  $query: String
) {
  viewer {
    ...instantSearch_viewer
    id
  }
}

fragment instantSearch_viewer on Viewer {
  trackInstantSearch(query: $query) {
    artists {
      id
      name
      slug
    }
    tracks {
      id
      slug
      title
      artist {
        name
        id
      }
    }
    taxonomies {
      id
      internal_id
      name
      terms {
        id
        name
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "query",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "instantSearchRefetchQuery",
  "id": null,
  "text": "query instantSearchRefetchQuery(\n  $query: String\n) {\n  viewer {\n    ...instantSearch_viewer\n    id\n  }\n}\n\nfragment instantSearch_viewer on Viewer {\n  trackInstantSearch(query: $query) {\n    artists {\n      id\n      name\n      slug\n    }\n    tracks {\n      id\n      slug\n      title\n      artist {\n        name\n        id\n      }\n    }\n    taxonomies {\n      id\n      internal_id\n      name\n      terms {\n        id\n        name\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "instantSearchRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "instantSearch_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "instantSearchRefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "trackInstantSearch",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "query",
                "variableName": "query",
                "type": "String"
              }
            ],
            "concreteType": "InstantSearchResult",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "artists",
                "storageKey": null,
                "args": null,
                "concreteType": "Artist",
                "plural": true,
                "selections": [
                  v1,
                  v2,
                  v3
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tracks",
                "storageKey": null,
                "args": null,
                "concreteType": "Track",
                "plural": true,
                "selections": [
                  v1,
                  v3,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "title",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "artist",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Artist",
                    "plural": false,
                    "selections": [
                      v2,
                      v1
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "taxonomies",
                "storageKey": null,
                "args": null,
                "concreteType": "Taxonomy",
                "plural": true,
                "selections": [
                  v1,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "internal_id",
                    "args": null,
                    "storageKey": null
                  },
                  v2,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "terms",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TaxonomyTerm",
                    "plural": true,
                    "selections": [
                      v1,
                      v2
                    ]
                  }
                ]
              }
            ]
          },
          v1
        ]
      }
    ]
  }
};
})();
(node/*: any*/).hash = '8f72b42ec38b01b5e377b3614dbed99c';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/instantSearchRefetchQuery.graphql.js